import ReactDOM from 'react-dom';
import React from 'react';
import ToastModal from '../containers/ToastModal';

if (!window.toastModal) {
	window.toastModal = [];
}
if (!window.toastModalLt) {
	window.toastModalLt = [];
}
export default (props) => {
	props = props || {};
	let app = document.getElementById('app');

	let container = document.body;
	// let isbodyFirstChild = true;
	if (props.container) {
		if (props.container.body) {
			container = props.container.body;
		} else {
			container = props.container;
			// isbodyFirstChild = false;
		}
	} else if (app) {
		container = app;
	}
	let section = document.createElement('section');
	section.classList.add('toast-zijinyun-project');
	// if( isbodyFirstChild === false ){
	// 	section.classList.add('toast-isbodyFirstChild');
	// }
	props.mark && section.setAttribute('data-mark', props.mark);
	container.appendChild(section);
	const toasts = ReactDOM.render(<ToastModal {...props} />, section);
	return toasts;
};
